export async function fetchLoanMetaV2(loanId, token) {
  const response = await fetch(`/los/v2/loans/${loanId}/meta`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      Cache: "no-cache",
    },
  })
  if (response.status !== 200) {
    throw new Error(`loan meta request failed: ${response.status}`)
  }
  const js = await response.json()
  if (js.Status !== "OK") {
    throw new Error(js.Text || "loan meta request failed")
  }
  return js
}

/**
 * Partial update of loan overview fields (split-table dual-write on server).
 * @param {string} loanId
 * @param {Record<string, unknown>} patch
 * @param {string} token
 */
export async function patchLoanMetaV2(loanId, patch, token) {
  const response = await fetch(`/los/v2/loans/${loanId}/meta`, {
    method: "PATCH",
    headers: {
      Authorization: "Bearer " + token,
      Cache: "no-cache",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(patch),
  })
  if (response.status !== 200) {
    throw new Error(`loan meta update failed: ${response.status}`)
  }
  const js = await response.json()
  if (js.Status !== "OK") {
    throw new Error(js.Text || "loan meta update failed")
  }
  return js
}

export function shouldShowDispositionFields(stage, status) {
  return (
    stage === "Disposed" ||
    (stage === "Closing" && status === "LoanFunded")
  )
}
